<template>
	<div class="input_container">
		<i :class="'pre_icon iconfont ' + pre_icon"></i>
		<input
			v-bind:value="value"
			:type="type"
			@focus="inputFocus"
			class="input_el"
			ref="input_el"
			@blur="inputBlur"
			@input="$emit('input', $event.target.value)"
			:placeholder="placeholder"
		/>
		<i
			class="iconfont icon-deletorerror delete_icon"
			@click="clearInput"
			v-show="showDeleteIcon"
		></i>
		<p class="tip">{{ tip }}</p>
	</div>
</template>
<script>
export default {
	props: ["placeholder", "value", "type", "pre_icon"],
	model: {
		prop: "value",
		event: "input",
	},
	data() {
		return {
			tip: "",
      showDeleteIcon: false,
      timer: null
		};
	},
	methods: {
		setTip(tip) {
			this.tip = tip;
		},
		inputFocus() {
			this.showDeleteIcon = true;
		},
		inputBlur() {
			this.timer = setTimeout(() => {
				this.showDeleteIcon = false;
			}, 400);
    },
		clearInput() {
			this.$emit("input", "");
			this.$refs.input_el.focus();
		},
  },
  destroyed() {
    clearTimeout(this.timer)
    this.timer = null
  },
};
</script>
<style lang="scss" scoped>
input{
  width: 100%;
  font-size: 1.7rem;
  font-weight: 400;
  color: #333333;
  line-height: 2.4rem;
  padding: 1.2rem 4.7rem 1.2rem 4.3rem;
  border: none;
	background: transparent;
  border-bottom: 0.1rem solid rgba(222, 222, 222, 1);
  &::placeholder{
		color: rgba(51, 51, 51, .1);
	}
}
.input_container{
  position: relative;
  margin-bottom: 2rem;
  .pre_icon{
    position: absolute;
    left: 1rem;
    top: 47%;
    transform: translateY(-50%);
    border-right: 0.1rem solid #ddd;
		padding-right: 1rem;
	}
  .delete_icon{
    cursor: pointer;
    position: absolute;
    right: 1rem;
    top: 50%;
    color: #888;
		transform: translateY(-50%);
	}
}
</style>
